import React, { createRef } from 'react'
import MapboxAutocomplete from './ReactMapboxAutocomplete'
import { MAPBOX_API_KEY } from "../../../constants/index"
import { withRouter } from 'react-router-dom'
import QueryString from 'query-string'
import { Button } from 'components/elements'
import globeIcon from '../assets/images/searchbar/globe-icon.webp'
import { trackSearchFromHeader } from '../../elements/tracking/searchTracking.js'
import { trackSearchLocationFromGeneralPages } from './../../elements/klaviyoTracking/generalSearch'
import './mapboxSearchAutoComplete.css'
import './index.css'
import { getLocation } from 'components/context/SearchContainer'
var classnames = require('classnames')

const searchIcon = (
  <img
    height="75px"
    width="75px"
    className="globe-icon"
    src={globeIcon}
    alt="globe-icon"
    data-nosnippet
  ></img>
)

class MapboxSearchBar extends React.Component {
  constructor(props) {
    super(props)

    const parsedQueries = QueryString.parse(this.props.location.search)

    let urlLocation = parsedQueries.location

    if (parsedQueries.location) {
      urlLocation = parsedQueries.location
    }

    this.state = {
      address:
        this.props.defaultAddress !== undefined
          ? this.props.defaultAddress
          : '',
      errorMessage: '',
      headerHeight: 150,
      searchFocused: false,
      searchIconImage: searchIcon,
      searchIconPosition: 'left',
      lastSearch: urlLocation,
      suggestions: {},
      isFocused: false,
      resetSearchInput: false,
      lat: '',
      lng: '',
      result: '',
      text: ''
    }
  }

  inputRef = createRef()

  componentDidMount() {
    if (this.props.grabAddressFromURL) {
      let newParsedFilters = QueryString.parse(this.props.location.search)
      if (newParsedFilters?.location?.includes('Best Motorcycle')) {
        let cityAndState =
          newParsedFilters.location
            .split('The Best Motorcycle Rentals in ')[1]
            .trim() + ', USA'
        this.setState({ address: cityAndState })
      } else {
        this.setState({ address: newParsedFilters.location })
      }
    }
  }

  componentWillUnmount() {
    document.body.classList.remove('desktop-search-focused')
    document.body.classList.remove('mobile-search-focused')
  }

  componentDidUpdate(prevProps, props) {

    if (this.props.isMobile !== prevProps.isMobile) {
      document.body.classList.remove('mobile-search-focused')
      document.body.classList.remove('desktop-search-focused')
      this.setState({
        searchFocused: false,
        searchIconImage: searchIcon,
        searchIconPosition: 'left',
      })
    }
  }

  handleChange = (address) => {
    this.setState({
      address,
      errorMessage: '',
    })
  }

  suggestionSelect = (result, lat, lng, text) => {
    const updateLocationContainer = this.props.searchObject.updateLocation

    const selected = result
    if (this.props.headerBar === true) {
      trackSearchLocationFromGeneralPages(selected)
      // Generate random digits to replace the last two decimal places
      let randomLatDigits = Math.floor(Math.random() * 100)
      let randomLonDigits = Math.floor(Math.random() * 100)

      // https://trello.com/c/WJqiA9ys/5723-goose-egg-search-results-in-404-page
      /* when it's Goooseegg search and user selects same location from suggestion
          runSearch won't trigger due to no change in prevProp and current props(i.e lat, lng will be same)
          modify last two digits after decimal points
      */
      // Replace the last two digits after the decimal with random digits
      if (lat && lng) {
        lat = lat.slice(0, -2) + randomLatDigits.toString().padStart(2, '0')
        lng = lng.slice(0, -2) + randomLonDigits.toString().padStart(2, '0')
      }
    }
    setTimeout(() => {
      document.body.classList.remove('mobile-search-focused')
      document.body.classList.remove('desktop-search-focused')
    }, 1000)

    this.setState({
      isGeocoding: true,
      searchFocused: false,
      address: selected,
      searchIconImage: searchIcon,
      searchIconPosition: 'left',
      result,
      lat,
      lng,
      text
    })


    let mapboxInput = document.getElementsByClassName('react-mapbox-ac-input')
    if (mapboxInput.length > 0) {
      Array.from(mapboxInput).forEach(ele => {
        ele.value = selected
      })
    }

    this.setState({
      latitude: lat,
      longitude: lng,
      isGeocoding: false,

      lastSearch: selected,
    })

    updateLocationContainer({
      location: selected,
      lat: lat,
      lng: lng,
    })

    if (this.props.selectSubmit) {
      trackSearchFromHeader({
        search_location: selected,
        search_latitude: lat,
        search_longitude: lng,
      })

      const tempParsedQueries = QueryString.parse(this.props.location.search)

      // remove params that must always be replaced
      delete tempParsedQueries.location
      delete tempParsedQueries.latitude
      delete tempParsedQueries.longitude

      // remove distance filters by default (important!)
      delete tempParsedQueries.min_distance
      delete tempParsedQueries.max_distance

      // apply default distance rules
      tempParsedQueries.min_distance = 0
      tempParsedQueries.max_distance = 75

      // always override location & coords
      tempParsedQueries.location = selected
      tempParsedQueries.latitude = lat
      tempParsedQueries.longitude = lng

      // override makes if present
      if (this.props.makes) {
        tempParsedQueries.makes = this.props.makes
      }

      Object.keys(tempParsedQueries).forEach(key => {
        if (
          tempParsedQueries[key] === null ||
          tempParsedQueries[key] === undefined ||
          tempParsedQueries[key] === ''
        ) {
          delete tempParsedQueries[key]
        }
      })

      const url = `/search?${QueryString.stringify(tempParsedQueries)}`

      this.props.history.push(url)
    } else {
      this.props.onSelect(
        selected,
        lat,
        lng,
        updateLocationContainer,
      )
    }
  }

  handleCloseClick = () => {
    this.setState({
      address: '',
      latitude: null,
      longitude: null,
    })
  }

  handleError = (status, clearSuggestions) => {
    this.setState({ errorMessage: status })
    clearSuggestions()
  }

  clickOff = () => {
    let address = this.state.lastSearch
    this.setState({
      address,
      searchFocused: false,
      searchIconImage: searchIcon,
      searchIconPosition: 'left',
      resetSearchInput: true
    })
    const currentLocation = getLocation('location')
    const qs = QueryString.parse(this.props.location.search)
    let mapboxInput = document.getElementsByClassName('react-mapbox-ac-input')
    if (mapboxInput.length > 0) {
      Array.from(mapboxInput).forEach(ele => {
        ele.value = qs.location || currentLocation
      })
    }
    document.body.classList.remove('mobile-search-focused')
  }

  getGlobeIconClassName = () => {
    return this.props.gooseEggSearch ?
      "gooseEgg icon is-small is-left" :
      "icon is-small is-left"
  }

  handleInputWrapClick = (e) => {
    if (this.props.searchFrom !== 'homescreen' &&
      this.props.isMobile) {
      this.setState({ resetSearchInput: false })
      document.body.classList.add('mobile-search-focused')
    }

  }

  render() {
    const {
      address,
      searchFocused,
      searchIconImage,
      result, lat, lng, text
    } = this.state

    let { searchFrom } = this.props
    let searchBarInputClass = classnames(
      this.props.gooseEggSearch ?
        'search-input input form-control' :
        'search-input input form-control mapbox-search-input',
      this.props.className,
      {
        'search-input-desktop': this.props.isMobile === false,
        'search-input-mobile': this.props.isMobile === true,
        'search-input-focused': searchFocused === true,
      }
    )

    let controlClass = classnames('control is-relative mapbox-input-wrapper', null, {
      'has-icons-right': address,
      'has-icons-left':
        (this.props.isMobile && !address) || !this.props.isMobile,
    })

    return (
      <>
        <div className={"search-header-wrapper " + searchFrom}>
          <div className='field mb-0 header-search-input-wrap'
            onClick={(e) => {
              e.preventDefault()
              this.handleInputWrapClick(e)
            }}
          >
            <div className={controlClass}>
              <MapboxAutocomplete
                publicKey={MAPBOX_API_KEY}
                inputClass={searchBarInputClass}
                onSuggestionSelect={(result, lat, lng, text) => {
                  const scrollableDiv = document.getElementById('scrollableDiv')
                  if (scrollableDiv) {
                    scrollableDiv.scrollTo({ top: 0,})
                  }
                  setTimeout(() => {
                    this.suggestionSelect(result, lat, lng, text)
                  }, 200)
                }}
                resetSearch={false}
                placeholder={this.props.searchPlaceHolder}
                ref={this.inputRef}
                country="us"
                resetSearchInput={this.state.resetSearchInput}
              />
              {this.props.isMobile && !this.state.address && (
                <div>
                  <span className={this.getGlobeIconClassName()}>
                    {this.props.overRideIcon
                      ? this.props.overRideIcon
                      : this.props.isHeaderSearchbar
                        ? null
                        : searchIconImage}
                  </span>
                </div>
              )}
              {!this.props.isMobile && (
                <span className={this.getGlobeIconClassName()}>
                  {this.props.overRideIcon
                    ? this.props.overRideIcon
                    : searchIconImage}
                </span>
              )}
              {!this.props.isMobile && this.props.isHeaderSearchbar && (
                <button
                  className="icon is-small is-right header-search-icon"
                  style={{
                    pointerEvents: 'initial',
                    textDecoration: 'none',
                    background:
                      'linear-gradient(180deg, #FFEC3B 0%, #E2BC00 100%)',
                    borderRadius: '20px',
                    border: 'none',
                    color: '#000000',
                    marginTop: '5px',
                    marginRight: '7px',
                    cursor: 'pointer',
                  }}
                  onClick={(e) => {
                    e.preventDefault()
                    const scrollableDiv = document.getElementById('scrollableDiv')
                    if (scrollableDiv) {
                      scrollableDiv.scrollTo({ top: 0,})
                    }
                    setTimeout(() => {
                      this.suggestionSelect(result, lat, lng, text)
                    }, 200)
                  }}
                >
                  <i
                    className="fal fa-search"
                    style={{ fontWeight: '600' }}
                  ></i>
                </button>
              )}
            </div>
          </div>
          {this.props.isMobile && (
            <Button
              className="search-header-cancel-button"
              onClick={() => this.clickOff()}
            >
              Cancel
            </Button>
          )}
        </div>
      </>
    )
  }
}

export default withRouter(MapboxSearchBar)

MapboxSearchBar.defaultProps = {
  grabAddressFromURL: true,
  selectSubmit: true,
  onSelect: function () { },
  searchPlaceHolder: 'Search Places...',
  focusSearch: false,
  onBlur: function () { },
  onFocus: function () { },
  searchObject: null,
  defaultAddress: null,

  //Style Related:
  inputClassName: null,
  overRideIcon: false,
  size: 'big',
}
